import React from 'react'
import { ChatMessageProvider } from './Context'
import { Layout } from './Layout'

export const Page = () => {
  return (
    <ChatMessageProvider>
      <Layout />
    </ChatMessageProvider>
  )
}
